/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Modal_Description_IntroInputs */



/**
* | output |
* | --- |
* | "Update the character and line position of all" |
*
* @param {Position_Modal_Description_IntroInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_description_intro = /** @type {((inputs?: Position_Modal_Description_IntroInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Description_IntroInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre a jour la position des caracteres et des lignes de tous les")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisiere die Zeichen- und Zeilenposition aller")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna la posizione del carattere e della riga di tutti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновите символ и позицию строки для всех")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar el carácter y la posición de línea de todos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新所有字符和行的位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべての文字と行の位置を更新します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी वर्णों और पंक्ति की स्थिति को अपडेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualize a posição dos caracteres e das linhas de todos os itens.")
	return /** @type {LocalizedString} */ ("Update the character and line position of all")
});